import { useEffect, useRef } from "react";

import { realTimeNotificationClient, RealTimeNotificationEventCallback, RealTimeNotificationEventType } from "../Api/RealTimeNotification/SignalRClient";

/**
 * A hook to react to real-time notification events.
 * @param eventType The event type.
 * @param callback The action to run when an event happens.
 */
function useRealTimeNotificationEvents(eventType: RealTimeNotificationEventType, callback: RealTimeNotificationEventCallback, dependencies: React.DependencyList): void {
    const realTimeNotificationSub = useRef("");

    useEffect(
        () => {
            realTimeNotificationSub.current = realTimeNotificationClient.registerToEvent(eventType, callback);
            callback(realTimeNotificationClient); // immediately call the callback with the current client state

            return () => {
                realTimeNotificationClient.unregisterFromEvent(realTimeNotificationSub.current);
            };
        },

        // eslint-disable-next-line react-hooks/exhaustive-deps
        dependencies
    );
}

export { useRealTimeNotificationEvents };
